import { CustomModal } from "./Modal";
import { useGame } from "../contexts";
import { BoxContainer } from "./Common";
import { Button } from "antd";
import { GameStates, playAudio, DataClass, currencyFormat } from "../utility";
import { AudioConstant } from "../audio";

export const OutOfRatRaceBox = () => {
  const { currentPlayer, yourTurn, updateRoom } = useGame();

  const enterFastTrack = async () => {
    playAudio(AudioConstant.enterFT,currentPlayer);
    await updateRoom({ gameState: GameStates.enterFastTrack });
  };

  const playerDream = DataClass.dreams.find((d) => d.text === currentPlayer?.dream);
  const dreamCost = playerDream?.cost || 50000;

  return (
    <CustomModal>
      <BoxContainer>
        <h2>CONGRATULATIONS!</h2>
        <p>YOU ARE OUT OF THE RAT RACE!</p>

        <p>
          {currentPlayer?.name} has built up their passive income to be greater
          than their total expenses and may now enter the Fast Track.
        </p>
        <p>
          If you enter, you will receive 100x your passive income in cash and
          race to increase your CASHFLOW DAY income by {currencyFormat(dreamCost)} to achieve your dream: <b>{currentPlayer?.dream}</b>.
        </p>
        {yourTurn && (
          <>
            <Button type="primary" block onClick={() => enterFastTrack()}>
              Enter Fast Track
            </Button>
          </>
        )}
      </BoxContainer>
    </CustomModal>
  );
};
